import React from 'react';
import { Flex, Image, Layout, Typography } from 'antd';
import { PrivacyBox } from './styles';
import Footer from '../_partials/Footer';

const { Title, Paragraph } = Typography;

export default function TermsOfService() {
  const myStyleLayout = {
    height: '100%',
    background: 'linear-gradient(90deg, #2e394b 0%, #4e6180 50%, #2e394b 100%)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important",
  };

  return (
    <Layout className="layout" style={myStyleLayout}>
      <Flex vertical align="center" justify="center" style={{ marginTop: 20 }}>
        <Image width={170} height="auto" src="images/logo-horizontal-02.png" preview={false} />
        <Title level={8} style={{ color: '#fff' }}>
          Termos de Serviço
        </Title>
      </Flex>
      <PrivacyBox>
        <Typography>
          <Title level={2}>Termos de Serviço - Nobre Eventos</Title>
          <Paragraph>
            Estes Termos de Serviço (<b>&quot;Termos&quot;</b>) regem o uso do sistema <b>Nobre Eventos</b>, disponível
            em <b>app.nobreeventos.com.br</b>, uma plataforma privada para gestão e administração de eventos da empresa
            Nobre. Ao acessar ou utilizar o sistema, você concorda integralmente com estes Termos.
          </Paragraph>

          <Title level={3}>1. Acesso e Registro</Title>
          <Paragraph>
            O acesso ao sistema é restrito e somente permitido a usuários cadastrados e autorizados pelo administrador
            do sistema. Não é permitido criar contas de forma autônoma. O administrador determina permissões específicas
            de acesso e funcionalidades para cada usuário, podendo limitar ou ampliar o que cada conta pode visualizar
            ou manipular.
          </Paragraph>

          <Title level={3}>2. Obrigações do Usuário</Title>
          <Paragraph>Ao utilizar o Nobre Eventos, o usuário concorda em:</Paragraph>
          <ul>
            <li>Manter suas credenciais de acesso em sigilo e seguras;</li>
            <li>Utilizar o sistema exclusivamente para fins relacionados à sua função;</li>
            <li>
              Não realizar atividades que possam comprometer a integridade, segurança ou funcionamento do sistema;
            </li>
            <li>
              Notificar imediatamente o administrador sobre qualquer uso não autorizado ou suspeita de violação de
              segurança;
            </li>
            <li>Respeitar os direitos de propriedade intelectual e dados de terceiros.</li>
          </ul>

          <Title level={3}>3. Conteúdo e Propriedade Intelectual</Title>
          <Paragraph>
            Todo conteúdo do sistema, incluindo textos, imagens, documentos e informações de eventos, é de propriedade
            da Nobre ou de terceiros licenciantes. O usuário não pode copiar, modificar, distribuir ou utilizar qualquer
            conteúdo sem autorização expressa. O uso de dados exportados ou compartilhados deve respeitar estritamente
            as finalidades profissionais e legais.
          </Paragraph>

          <Title level={3}>4. Privacidade e Proteção de Dados</Title>
          <Paragraph>
            O tratamento de dados pessoais no sistema segue a{' '}
            <b>Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018)</b>. Todos os dados de usuários e eventos são
            armazenados de forma segura, e o acesso é controlado por permissões individuais. Para mais informações sobre
            privacidade, consulte a Política de Privacidade do sistema.
          </Paragraph>

          <Title level={3}>5. Responsabilidades e Limitação de Responsabilidade</Title>
          <Paragraph>A Nobre Eventos não se responsabiliza por:</Paragraph>
          <ul>
            <li>Perdas ou danos decorrentes de mau uso das credenciais;</li>
            <li>Erros ou falhas causados por terceiros não autorizados;</li>
            <li>Perdas financeiras, interrupções ou falhas de eventos originadas por uso inadequado do sistema.</li>
          </ul>
          <Paragraph>
            O usuário é responsável por todas as ações realizadas sob sua conta e deve garantir que suas atividades
            estejam em conformidade com estes Termos e com a legislação aplicável.
          </Paragraph>

          <Title level={3}>6. Modificações no Sistema e Termos</Title>
          <Paragraph>
            A Nobre Eventos pode, a qualquer momento, alterar funcionalidades do sistema ou atualizar estes Termos. Tais
            alterações serão comunicadas por meio do sistema ou canais oficiais. O uso contínuo da plataforma após
            notificações constitui aceitação das alterações.
          </Paragraph>

          <Title level={3}>7. Suspensão e Encerramento de Conta</Title>
          <Paragraph>
            O administrador tem o direito de suspender ou encerrar a conta de qualquer usuário em caso de:
          </Paragraph>
          <ul>
            <li>Violação destes Termos;</li>
            <li>Uso não autorizado ou suspeita de fraude;</li>
            <li>Solicitação do próprio usuário para exclusão da conta;</li>
            <li>Necessidade operacional ou legal.</li>
          </ul>

          <Title level={3}>8. Exceções Legais e Obrigações Regulamentares</Title>
          <Paragraph>
            Algumas informações podem ser retidas temporariamente caso haja exigência legal, regulatória ou judicial.
            Após cumprimento dessas obrigações, os dados são eliminados de forma segura.
          </Paragraph>

          <Title level={3}>9. Contato e Suporte</Title>
          <Paragraph>
            Para dúvidas, solicitações ou esclarecimentos sobre estes Termos de Serviço, o usuário pode contatar a
            equipe administrativa da Nobre Eventos por meio dos canais oficiais do sistema.
          </Paragraph>

          <Title level={3}>10. Disposições Finais</Title>
          <Paragraph>
            Estes Termos constituem o acordo completo entre o usuário e a Nobre Eventos em relação ao uso do sistema.
            Caso qualquer disposição seja considerada inválida ou inexequível, as demais permanecerão em pleno vigor.
            Estes Termos são regidos pela legislação brasileira.
          </Paragraph>
        </Typography>
      </PrivacyBox>
      <Footer bg="transparent" color="#fff" />
    </Layout>
  );
}
